<!-- What this mode remembers about him.

     Endurance always had one of these — a record card under the blurb — and the
     other six pre-game screens had a title, a paragraph and a button, then two
     thirds of a phone of nothing. That is invisible one screen at a time and
     obvious with all seven side by side, which is the only way it was ever
     going to be found.

     Reads the runs the app already writes: `finishRun` records every run with
     its mode, so a per-mode best needs no new stored field. Before the first
     game there is nothing to show and the card says so rather than showing a
     zero, because "0" reads as a score he got. -->
<template>
  <div class="ex-total" style="margin-top: var(--sp-5)">
    <div>
      <div class="k">Best score</div>
      <div class="n" :class="{ tabular: best > 0 }" :style="best ? null : 'font-size: var(--text-lg)'">
        {{ best ? best.toLocaleString() : 'Not yet' }}
      </div>
    </div>
    <div v-if="played">
      <div class="k">Played</div>
      <div class="n tabular">{{ played }}</div>
    </div>
    <div v-if="bestStreak">
      <div class="k">Best streak</div>
      <div class="n tabular">{{ bestStreak }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { runs } from '../store.js';

const props = defineProps({ mode: { type: String, required: true } });

const mine = computed(() => runs.value.filter((r) => r.mode === props.mode));
const best = computed(() => mine.value.reduce((m, r) => Math.max(m, r.score ?? 0), 0));
const played = computed(() => mine.value.length);
const bestStreak = computed(() => mine.value.reduce((m, r) => Math.max(m, r.bestChain ?? 0), 0));
</script>
